<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 16 16"
  fill="none"
  stroke="none"
>
  <g
    class="currentLayer"
    style="">
    <title>Layer 1</title>
    <circle cx="8" cy="8" r="8" [attr.fill]="color" id="svg_1" class="selected"/>
    <path
      d="M10 4L6 8L10 12"
      stroke="white"
      stroke-width="1.5"
      id="svg_2"
      class="selected"
      transform="rotate(-179.99998474121094 8.000000000000002,7.999999999999999) "/>
  </g>
</svg>